
import { Constant } from "@/helpers/constant";
import { Component, Vue } from "vue-property-decorator";
import UpSkillService from "../../../../services/upSkillService";
import JobseekerService from "../../../../services/jobseekerService"; 
import moment from "moment";
import ViewCourseDetails from "../../pages/viewCourseDetails/viewCourseDetails.vue";
import EmployerAdvertisement from "@/models/employerAdvertisement";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
import RandomImageService  from "../../../../services/randomImageService";
import Jobseeker from "@/models/jobseeker";
@Component({
  components: {
    ViewCourseDetails: ViewCourseDetails
  },
})
export default class CourseHistoryForJobseeker extends Vue {
  $loading: any;
  courses = [];
  tee = [];
  viewCourse = [];
  rtistUrl = Constant.Rtist_url;
  thekeduaUrl = Constant.TheKedua_url;
  display: boolean = false;
  page: number = 1;
  formType = null;
  icNumber = "";
  profileId="";
  adCount: number = 0;
  ads: EmployerAdvertisement[]=[];
  selectedLanguage: string='';
  courseListData:any=[];
  appliedCourse: any=[];
  filtervalue: any='';
  labelfilter: string='Newest First';
 appliedCourseLength:any=null;
 ratingValue:number = null;
  jobseeker: Jobseeker = new Jobseeker();
  withdrawalCount: any;
  appealStatus: any;
  withdrawalArray: any[];
  max_withdrawal: any;
  teeModalOpen:boolean = false;
  tee1: any;
  tee2: any;
  tee3: any;
  tee4: any;
  tee5: any;
  tee6: any;
  tee7: any;
  tee8: any;
  teeapp: any;
  teecourse: any;
  applealReason:any;
  todaydate: any;
  passportNum:any='';

  async created() {
    if (
      localStorage.getItem("icNumber") != undefined &&
      localStorage.getItem("icNumber") != null
    ) {
      // this.icNumber = localStorage.getItem("icNumber");
      // this.passportNum = localStorage.getItem("passportNumber");

      let icNum = localStorage.getItem("icNumber");
      let passprotNum = localStorage.getItem("passportNumber");

      this.profileId = localStorage.getItem("profileId");
      //this.icNumber=icNum;
      this.icNumber = passprotNum == '' || passprotNum == "null" ? icNum : '';
      this.passportNum = passprotNum == "null" ? "" : passprotNum;

      //this.profileId=localStorage.getItem("profileId");
      this.getAdminSetting();
      await this.getJobseekers();
      this.getAppliedCourse();
    }
    if (
      localStorage.getItem("loginType") != undefined &&
      localStorage.getItem("loginType") != null &&
      localStorage.getItem("loginType") == "jobseeker"
    ) {
      // this.getAds();
    }

    this.selectedLanguage = localStorage.getItem("selectedlanguage");
    if (this.selectedLanguage == 'en') {
      this.courseListData = TranslateEn.courseListData;
      this.labelfilter = this.courseListData.newestFirst;
    } else {
      this.courseListData = TranslateMalay.courseListData;
      this.labelfilter = this.courseListData.oldestFirst;
    }
  }
  replaceAdUrl(adFileUrl) {
    let url = "";
    if (adFileUrl != undefined && adFileUrl != null && adFileUrl != "") {
      url = adFileUrl.replace(Constant.OSSInternalURL, Constant.OSSReplaceURL);
      return url;
    }
  }
  getAds(){
    let data = {
      provider:Constant.JOBSEEKER_PROVIDER,
      page:1
    };
    let loader = this.$loading.show();
    JobseekerService.listApprovedAds(data).then(response => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          ) {
            if (response.data.data.count != null) {
              this.adCount = response.data.data.count;
            }
            if (response.data.data.ads != null) {
              this.ads = response.data.data.ads;
            } else {
              this.ads = [];
            }
          }
        }
      }
    });
  }

  getCourses() {
    let req = {
      provider: Constant.JOBSEEKER_PROVIDER,
      nricnumber: this.icNumber,
    };
    
    if(localStorage.getItem("provider") != undefined && localStorage.getItem("provider") != null && localStorage.getItem("provider")==Constant.EMPLOYER_PROVIDER){
      req.provider = Constant.EMPLOYER_PROVIDER
    }
    let loader = this.$loading.show();
    UpSkillService.getCourseHistoryForTrainee(req).then((response) => {
      loader.hide();
      if (response != undefined) {
           if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null &&
            response.data.data.data != undefined &&
            response.data.data.data != null &&
            response.data.data.data.length > 0
          ) {
            this.courses = response.data.data.data;
          } else {
            this.courses = [];
          }
          this.tee = response.data.data.tee;
        }
      }
      }
    });
  }
    //   onPage(event) {
    //   this.page = event.page +1;
    //   this.getCourses();
    // }

  getDaysFromDate(createdDate) {
    const timeDiff = Math.abs(
      (new Date() as any) - (new Date(createdDate) as any)
    );
    const days = timeDiff / (1000 * 60 * 60 * 24);
    return Math.round(days);
  }
    formatDate(value){
     let val = moment(String(value)).format('Y-MM-DD');
     if(val == "Invalid date"){
       return "";
     }
     else{
       return val;
     }
  }
    formatTrainingDate(value){
    let val = moment(String(value)).format('DD-MM-YYYY');
     if(val == "Invalid date"){
       return "";
     }
     else{
       return val;
     }
  }
    displayCourseDetails(course) {
    this.viewCourse = course;
    this.display = true;
  }
    getAppliedCourse() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.ADMIN_PROVIDER,
      nricnumber:this.icNumber,
      passport_number : this.passportNum,
      filter:this.filtervalue
    };
    UpSkillService.getCourseHistoryForTrainee(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (response.data != undefined && response.data != null && response.data.data.data != undefined && response.data.data.data != null )
           {            
             this.appliedCourse =  response.data.data.data;
             this.appliedCourseLength = this.appliedCourse.length;
             this.tee = response.data.data.tee;
           }
        }
      }
    });
  }

  confirmWithdrawCourseApply(courseId){
  this.$fire({title: 'Are you sure you want to withdraw from this course?',
       text:"",showCancelButton: true,confirmButtonText: 'Confirm',
       type: "warning",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
    .then((Okay) => {
        if(Okay.value){
          this.withdrawCourseApply(courseId);
        }
    });
  }

     withdrawCourseApply(courseId) {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      nric_number:this.icNumber,
      course_id:courseId,
      passport_number : this.passportNum
    };
    UpSkillService.withdrawCourse(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.data.statusCode == 200) {
           this.$fire({title: 'Success',text:response.data.message,showCancelButton: false,confirmButtonText: 'OK',type: "success",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
               this.getAppliedCourse();
               this.getJobseekers();
        }
      }
    });
  }
  filterCourse(data:any){
        if(data == 'old'){
          this.labelfilter=this.selectedLanguage === "en" ? this.courseListData.oldestFirst : this.courseListData.oldestFirst;
          this.filtervalue='asc';
          this.getAppliedCourse();
        }else{
         this.labelfilter=this.selectedLanguage === "en" ? this.courseListData.newestFirst : this.courseListData.newestFirst;
          this.filtervalue='';
          this.getAppliedCourse();
        }
  }
  ratingUpdate(courseId:any){
     let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      applicant_id:this.profileId,
      course_id:courseId,
      rating:this.ratingValue
    };
    UpSkillService.updateCourseRating(data).then((response) => {
      loader.hide();
      
      if (response != undefined) {
        if (response.data.statusCode == 200) {
         this.$toast.add({severity:'success', summary: 'Rating', detail:this.ratingValue+'Rating Updated Successfully', life: 3000});
        }
      }
    });
  }
    formatDateFor(value){
     const d = new Date(value); 
     let val = moment(d).format('DD MMMM YYYY');
     if(val == "Invalid date"){
      return "test"
     }
     else{
       return val
     }
  }
  randomImage(){
    return RandomImageService.randomImage();
  }
  randomCpImage(){
    return RandomImageService.randomCpImage();
  }

  confirmCancelApplyCourse(courseId){
     if(this.withdrawalCount >= this.max_withdrawal){
 this.$fire({title: 'Are you sure?',
       text:"You have reached the maximum Course Cancellation limit. Kindly note that if you Cancel you will be blocked from applying for Courses",showCancelButton: true,confirmButtonText: 'Confirm',
       type: "warning",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
    .then((Okay) => {
        if(Okay.value){
          this.withdrawCourseApply(courseId);
        }
    });
     }else{
       this.$fire({title: 'Are you sure?',
       text:"Please note, if the application is Approved, You will not be eligible to apply for other courses",showCancelButton: true,confirmButtonText: 'Confirm',
       type: "warning",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
    .then((Okay) => {
        if(Okay.value){
          this.withdrawCourseApply(courseId);
        }
    });
    }
  }

  async getJobseekers() {
    const loader = this.$loading.show();

    if (!this.$store.getters['dashboard/getJobseekerData']) {
      await this.$store.dispatch('dashboard/fetchJobseekerData')
    }

    loader.hide()

    this.jobseeker = this.$store.getters['dashboard/getJobseekerData']
    this.withdrawalCount = this.$store.getters['dashboard/getJobseekerData'].withdrawalCount;

    // JobseekerService.getJobSeekerById(this.profileId).then(
    //   (response) => {
    //     loader.hide();
    //     if (response != undefined && response.data != undefined) {
    //       if (response.data.status == 200) {
    //         if (response.data.data != null && response.data.data.length > 0) {
    //           this.jobseeker = response.data.data[0];
    //           this.withdrawalCount = response.data.data[0].withdrawalCount;
    //         }
    //       }
    //     }
    //   }
    // );
  }

   getAdminSetting() {
    this.todaydate = moment().format('YYYY-MM-DD');
    let loader = this.$loading.show();
    JobseekerService.getAdminSetting().then(
      (response) => {
        loader.hide();
        if (response != undefined && response.data != undefined) {
          
          if (response.data.statusCode == 200) {
            if (response.data.data.data != null && response.data.data.data.length > 0) {
               this.withdrawalArray =  response.data.data.data;
               for (let index = 0; index < this.withdrawalArray.length; index++) {
                if(this.withdrawalArray[index].field == 'max_withdrawal'){
                   this.max_withdrawal = this.withdrawalArray[index].value;
                }
               }
            }
          }
        }
      }
    );
  }

  getCertificateUrl(applicantId,courseId) {
    let url = "";
    url = Constant.SWV1_URL+'v1/courseCert?id='+applicantId+'&course_id='+courseId+'&lang='+this.selectedLanguage;
    return url;
  }

  courseDetails(id){
    localStorage.setItem("courseId",id)
    this.$router.push("/indiCourse?courseId="+id)
  }

  openTeeForm(applicantId,courseId){
    this.teeapp=this.icNumber;
    this.teecourse=courseId;
  this.teeModalOpen = true;
}
cancelTee(){
  this.teeModalOpen = false;
}
submitTee() {

  // alert('applealReason = '+this.applealReason);
  // alert('tee1 = '+this.tee1);
  // alert('tee2 = '+this.tee2);
  // alert('tee3 = '+this.tee3);
  // alert('tee4 = '+this.tee4);
  // alert('tee5 = '+this.tee5);
  // alert('tee6 = '+this.tee6);
  // alert('tee7 = '+this.tee7);
  // alert('tee8 = '+this.tee8);
  // console.log(localStorage);
    let data ={
       provider: Constant.JOBSEEKER_PROVIDER,
       user_id: localStorage.candEmail,
       course_id: this.teecourse,
       tee1: this.tee1,
       tee2: this.tee2,
       tee3: this.tee3,
       tee4: this.tee4,
       tee5: this.tee5,
       tee6: this.tee6,
      //  tee7: this.tee7,
      //  tee8: this.tee8,
    };
    // if(this.tee1 == undefined || this.tee2 == undefined || this.tee3 == undefined || this.tee4 == undefined || this.tee5 == undefined || this.tee6 == undefined || this.tee7 == undefined || this.tee8 == undefined) {
    if(this.tee1 == undefined || this.tee2 == undefined || this.tee3 == undefined || this.tee4 == undefined || this.tee5 == undefined || this.tee6 == undefined) {
      this.$fire({title: 'Failed',text: "Please complete all required fields",showCancelButton: false,confirmButtonText: 'OK',type: "error",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
    } else {
      let loader = this.$loading.show();
      JobseekerService.submitTee(data).then(response => {
        loader.hide();
        if (response != undefined) {
          if (response.status == 200) {
            if(response.data != undefined && response.data != null && response.data.data != undefined && response.data.data != null)
            {
    this.$fire({title: 'Success',text: "Assessment Successfully Submitted!",showCancelButton: false,confirmButtonText: 'OK',type: "success",
                backdrop: `
                rgba(0,0,1,0.4)
                center left
                no-repeat
                `}).then(() => {
    this.teeModalOpen = false;
    window.location.reload();
  });
                //  this.teeModalOpen = false;
                // //  this.applealReason = "";
                // window.location.reload();
            }
          }else{
            this.$fire({title: 'Failed',text: "Please contact system admin for this issue.",showCancelButton: false,confirmButtonText: 'OK',type: "error",
                backdrop: `
                rgba(0,0,1,0.4)
                center left
                no-repeat
                `})
                this.teeModalOpen = false;
          }
        }
      });
    }
  }

}
